

const removeTravel = (index, travels, callback) => {
    if (travels.length > 1) {
        const newTravels = travels.map((obj, i) =>
            i === index ? null : obj
        );
        let result = newTravels.filter(d => d !== null);
        callback(result);
    }
}


export default removeTravel;